import React from 'react'
import { observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import BoundaryListSearchResult from './BoundaryListSearchResult'
import ErrorForm from '../common/ErrorForm'

const BoundaryListSearch = ({ boundaryList, savingBoundaries, t }) => (
  <>
    {boundaryList.error && (
      <div className='boundary-list-pane__error'>
        <ErrorForm item={boundaryList} />
      </div>
    )}
    {boundaryList.searchLoading && (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '24px 8px', color: '#64748B', fontSize: '13px' }}>
        <div className='spinner' style={{ width: '14px', height: '14px', flexShrink: 0 }} />
        <span>{t('GLOBAL.SEARCHING', { defaultValue: 'Searching...' })}</span>
      </div>
    )}
    {!boundaryList.searchLoading && boundaryList.searchResults.length === 0 && (
      <div style={{ textAlign: 'center', padding: '24px 8px', color: '#94A3B8', fontSize: '13px' }}>
        {t('GLOBAL.NO_RESULTS', { defaultValue: 'No results found' })}
      </div>
    )}
    <ul className='boundary-tree-list'>
      {boundaryList.searchResults.map(result => (
        <BoundaryListSearchResult
          key={result.id}
          result={result}
          savingBoundaries={savingBoundaries}
        />
      ))}
    </ul>
  </>
)

export default withTranslation()(observer(BoundaryListSearch))
